<script context="module">
  export interface ITablePanel extends IPanelData {
    title: string;
    table: ITableData;
  }

  export interface ITableData {
    cells: ITableCell[][];
    useFirstRowAsHeader: boolean;
  }

  export interface ITableCell {
    align: TableAlignEnum;
    plainText: string;
    value: string;
  }

  export enum TableAlignEnum {
    "cell-right",
    "cell-center",
    "cell-left",
  }
</script>

<script>
  import { onMount } from "svelte";
  import MobileView from "./MobileView.svelte";
  import DeskView from "./DeskView.svelte";
  import type { IPanelData } from "../../../core/types";
  import { addThemeClass, md } from "../../../core";

  export let data: ITablePanel;

  let w = window.innerWidth;
  $: isMobile = w < md;

  onMount(() => {
    window.addEventListener("orientationchange", changeWidth);
    return () => window.removeEventListener("orientationchange", changeWidth);
  });

  function changeWidth() {
    setTimeout(() => (w = window.innerWidth), 300);
  }
</script>

<section class="table-panel g-centered" use:addThemeClass={data}>
  {#if isMobile}
    <div class="mob">
      <MobileView {data} let:cell>
        <slot {cell} />
      </MobileView>
    </div>
  {/if}

  <div class="desk">
    <DeskView {data} let:cell>
      <slot {cell} />
    </DeskView>
  </div>
</section>

<style lang="scss">
  .table-panel {
    margin-bottom: 30px;

    @include sm {
      margin-bottom: 40px;
    }
  }

  .mob {
    @include md-hide;
  }
  .desk {
    @include md-show;
  }
</style>
